import * as PIXI from "pixi.js";
import { Coord, SelectBoxConfig } from "../../../types/Interface";


export default class SelectBoxFactory {
  static genItemCon(_config: Readonly<SelectBoxConfig>, label: string, index?: number) {
    const config = { ..._config };
    const con = new PIXI.Container();

    if (index) {
      config.y = index * config.height - 16;
    }
    const labelCoord = {
      x: config.x - config.width / 2 + 10,
      y: config.y
    }
    con.addChild(
      this.genBg(config, index ? true : false),
      this.genLabel(label, labelCoord),
    );
    return con;
  }

  static genBg(config: SelectBoxConfig, isChild: boolean) {
    const x = config.x - config.width / 2;
    const y = config.y - config.height / 2;

    const rect = new PIXI.Graphics()
      .rect(x, y, config.width, config.height)
      .fill({ color: !isChild ? config.fillColor : config.childFillColor })
      .stroke({ color: 0x000000, width: isChild ? 2 : 6 })

    if (!isChild) {
    }
    return rect
  }

  static genLabel(_label: string, coord: Coord) {
    const label = new PIXI.Text({ text: _label });
    label.anchor.set(0, .5);
    Object.assign(label, coord);
    return label;
  }

  static genArrow(graphic: PIXI.Graphics, config: SelectBoxConfig, direction: "up" | "down") {
    const arrowCoord = {
      x: config.x + config.width / 2 - 20,
      y: config.y
    }
    const offsetY = (direction == "up" ? - 5 : 5);
    graphic
      .clear()
      .moveTo(arrowCoord.x, arrowCoord.y - offsetY)
      .lineTo(arrowCoord.x + 10, arrowCoord.y + offsetY)
      .lineTo(arrowCoord.x - 10, arrowCoord.y + offsetY)
    graphic.fill(0x000000);
    
  }

  static genMask(config: SelectBoxConfig, length: number) {
    const x = config.x - config.width / 2 - 4;
    const y = config.y - config.height / 2 - 3;
    const w = config.width + 8;
    const h = config.height * (length + 1.5);
    const graphic = new PIXI.Graphics()
      .rect(x, y, w, h)
      .fill(0xFF0000);
    return graphic
  }
}